var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1.4 18.7 5c.7.7.2 2-.9 2h-4.6c-.7 0-1.2-.5-1.2-1.2V1.2c0-1.1 1.3-1.6 2.1-.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0C1.7 0 1 .7 1 1.5v17c0 .8.7 1.5 1.5 1.5h15c.8 0 1.5-.7 1.5-1.5v-7.9c0-.9-.7-1.6-1.5-1.6h-6c-.8 0-1.5-.6-1.5-1.5v-6C10 .7 9.3 0 8.5 0h-6z"
  })));
};
export default SvgDocument;